import axios from "axios";
import qs from "qs";

export default class Base
{
	constructor ()
	{
		this.data = {};
	}

	setData (v)
	{
		this.data = v;
		return this;
	}

	getUrl ()
	{
		return '';
	}

	getMethod ()
	{
		return '';
	}

	call ()
	{
		return new Promise((resolve, reject) =>
		{
			const method = this.getMethod();

			let url = this.getUrl();

			let config = {
				method
			};

			if (method === 'GET')
			{
				url += "?" + qs.stringify(this.data);
			}
			else
			{
				config.data = this.data;
			}

			config.url = url;

			axios
				.request(config)
				.then(response =>
				{
					resolve(response.data);
				})
				.catch(error =>
				{
					reject(error.response.data);
				})
		});
	}
}